exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cleaning-wizard img {\n  vertical-align: unset;\n}\n", ""]);

// exports
